import { useRef, useState } from "react";

// Touch-swipe card: right → onRight (snooze), left → onLeft (done). Falls back to buttons on desktop.
export default function SwipeCard({ children, rightLabel, leftLabel, onRight, onLeft, onTap, testId }) {
  const [dx, setDx] = useState(0);
  const start = useRef(null);
  const moved = useRef(false);
  const T = 90;
  const x = (e) => (e.touches ? e.touches[0].clientX : e.clientX);
  const onStart = (e) => { start.current = x(e); moved.current = false; };
  const onMove = (e) => { if (start.current != null) { const d = x(e) - start.current; if (Math.abs(d) > 5) moved.current = true; setDx(d); } };
  const onEnd = () => {
    if (dx > T) onRight(); else if (dx < -T) onLeft();
    setDx(0); start.current = null;
  };
  const bg = dx > 20 ? "#C99A1E" : dx < -20 ? "#2E7D4F" : "transparent";
  return (
    <div className="relative overflow-hidden rounded-sm" data-testid={testId}>
      <div className="absolute inset-0 flex items-center justify-between px-4 font-mono text-[10px] uppercase text-white" style={{ background: bg }}>
        <span style={{ opacity: dx > 20 ? 1 : 0 }}>{rightLabel}</span><span style={{ opacity: dx < -20 ? 1 : 0 }}>{leftLabel}</span>
      </div>
      <div onTouchStart={onStart} onTouchMove={onMove} onTouchEnd={onEnd} onPointerDown={onStart} onPointerMove={onMove} onPointerUp={onEnd} onPointerLeave={() => { if (start.current != null) onEnd(); }}
        onClick={() => { if (!moved.current) onTap(); }} style={{ transform: `translateX(${dx}px)`, transitionDuration: start.current == null ? "150ms" : "0ms", touchAction: "pan-y" }}
        className="relative bg-white border border-[#DFDAD0] px-4 py-3 transition-transform select-none cursor-grab">
        {children}
      </div>
    </div>
  );
}
